import { Alert } from 'antd';

export type TimezoneInfoProps = {
  timezone: string;
};

export const TimezoneInfo = ({ timezone }: TimezoneInfoProps) => {
  const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const isDifferentTimezone = timezone !== userTimezone;

  if (!isDifferentTimezone) return null;

  return (
    <Alert
      type="warning"
      showIcon
      message={
        <>
          The selected company is located in the <span style={{ fontWeight: 600 }}>{timezone}</span>{' '}
          timezone. Business hours are displayed in the company's local time.
        </>
      }
    />
  );
};
